import classnames from "classnames";
import { AuswahlAccessor } from "../Auswahl";
import React from "react";
import { RenderImage } from "./RenderImage";
import { BreitenEingabe, breitenEingabeLabel, HöhenEingabe } from "../ElementSizeComponents";
import { TorOptionen } from "../zauneditor/TorOptionen";
import { AuswahlVerteilungsstrategie } from "./AuswahlVerteilungsstrategie";

export function RightMenu({ selected: object }) {
  return (
    <aside
      className={classnames("right-menu page-initial-hidden bordered")}
      role="complementary"
      aria-label={I18N("aria::Eigenschaften")}
      data-group-key="Eigenschaften"
    >
      <AuswahlVerteilungsstrategie />
      {object && <Details object={object} />}
    </aside>
  );
}

export function Details({ object }) {
  return (
    <>
      <RenderImage jaco={object} />

      {object.isElement && (
        <>
          <AuswahlAccessor accessorKey={"EasyMass"} />
          {breitenEingabeLabel(object)}
          <BreitenEingabe object={object} />
        </>
      )}
      {object.isElement && (
        <>
          {I18N("Höhe")}
          <HöhenEingabe object={object} />
          <AuswahlAccessor accessorKey={"Füllung"} />
        </>
      )}

      {object.isTor && <TorOptionen tor={object} />}

      {object.isPfosten && <PfostenEigenschaften pfosten={object} />}
    </>
  );
}

function PfostenEigenschaften({ pfosten }) {
  return (
    <>
      <AuswahlAccessor accessorKey="Pfostenfarbe" />
      <AuswahlAccessor accessorKey="Pfostenart" />
      <AuswahlAccessor accessorKey="Bodenbefestigung" />
      <AuswahlAccessor accessorKey="Verbundanker" />
      <AuswahlAccessor accessorKey="Montageadapter" />
      <AuswahlAccessor accessorKey="Ummantelung" />
      <AuswahlAccessor accessorKey="Elementhalter" />
    </>
  );
}
